// Re-export from browse-category file (not directory) for backward compatibility
export { default } from './browse-category';
export * from './browse-category';
